// 슬롯별 더미 응답 데이터 — 시나리오 키(responseKey)로 조회하는 순수 데이터 테이블
import type { SlotResponseData } from './Home.types';
import { INITIAL_PROACTIVE_CARDS } from './Home.data';

export const SLOT_RESPONSE_DATA: Record<string, SlotResponseData> = {
  /* ── 홈 프롬프트: 거래처 미수금 + ONEFFICE 보고서 ── */
  'ar-report': {
    streamingTitle: 'ERP 회계 조회 및 ONEFFICE 보고서 작성 중...',
    doneTitle: '거래처 미수금 현황 분석 완료',
    steps: [
      { label: 'ERP 회계에서 거래내역을 조회하고 있어요' },
      { label: '미수금 거래처를 선별·분석하고 있어요' },
      { label: 'ONEFFICE 보고서 초안을 작성하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '이번주 미수금이 있는 거래처를 ERP 회계에서 조회하고, ONEFFICE 보고서를 생성하고 있어요.',
    bubbleText: '세금계산서 발행, 독촉장 작성, 거래처 미팅 준비 3가지를 제안드려요. 어떤 것부터 시작할까요?',
    moduleChips: [
      { label: '[ERP 회계 ▶ 거래내역]', iconType: 'bar', done: true },
      { label: '[ONEFFICE ▶ 보고서 초안]', iconType: 'doc', done: true },
    ],
    resultText: '분석 결과, 이번주 미수금이 있는 거래처는 총 3곳이에요:',
    arTable: [
      { name: '㈜아사히 전자',      amount: '2,450,000', dueDate: '2025.08.25', person: '田中 部長', statusText: '연체',     statusCls: 'stOverdue'  },
      { name: '도쿄 물산 주식회사', amount: '1,820,000', dueDate: '2025.08.28', person: '佐藤 씨',  statusText: '마감 임박', statusCls: 'stWarning'  },
      { name: '오사카 상사',        amount: '3,100,000', dueDate: '2025.08.30', person: '山田 씨',  statusText: '처리 중',   statusCls: 'stProgress' },
    ],
    note: 'ONEFFICE 보고서 초안이 생성되었어요. 내용을 검토한 후 제출할 수 있어요.',
    noteAction: { label: '보고서 열기 →', path: '/oneffice/report' },
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    postSuggestCards: [
      {
        id: 101,
        title: '세금계산서 자동 발행',
        metaType: 'date',
        metaLabel: '마감일',
        metaDate: '2025.08.31 (일)',
        desc: '미수금 회수 후 ERP 세무에서 세금계산서를 자동 발행합니다.',
        actionLabel: '발행하기',
        actionStyle: 'solid',
      },
      {
        id: 102,
        title: '미수금 독촉장 초안',
        metaType: 'warn',
        desc: '3개 거래처에 보낼 독촉장 초안을 ONEFFICE에서 확인, 발송합니다.',
        actionLabel: '초안 보기',
        actionStyle: 'outline',
      },
       {
        id: 102,
        title: '독촉장 발송 대상 안내',
        metaType: 'warn',
        desc: '연체 중인(주)아사히 전자의 신용 위험을 AI에이전트가 심층 분석합니다.',
        actionLabel: '초안 보기',
        actionStyle: 'outline',
      },
    ],
    nextProActiveCards: INITIAL_PROACTIVE_CARDS,
  },
  'mou-mail': {
    doneTitle: '메일 브리핑 완료',
    steps: [
      { label: '파트너사 수신 메일을 확인하고 있어요' },
      { label: '일본어 원문과 첨부를 분석하고 있어요' },
      { label: '핵심 요청사항을 정리하고 있어요' },
      { label: '권장 처리 방향을 정리하고 있어요' },
    ],
    stepDur: 720,
    streamingText: '일본어 메일을 분석하고 MOU 요청 핵심 내용과 대응 흐름을 정리하고 있어요.',
    bubbleText: 'ONECHAMBER 자료 탐색, MOU 초안 준비, 메일 브리핑 확인 3가지를 제안드려요. 어떤 것부터 시작할까요?',
    moduleChips: [
      { label: '[메일 ▶ 일본어 파트너 메일]', iconType: 'bar', done: true },
    ],
    resultText: '',
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '',
    insightCard: {
      label: 'AI 인사이트',
      title: '파트너사의 요청 핵심을 파악했습니다',
      text: '일본어 장문 메일이지만 핵심은 명확합니다. 파트너사는 MOU 초안과 관련 레퍼런스 자료를 요청했고, 즉시 자료 탐색 후 문서 초안까지 이어갈 수 있습니다.',
    },
    briefingCard: {
      label: '메일 브리핑',
      title: '파트너십 검토를 위한 MOU 초안과 근거 자료 요청입니다',
      rows: [
        { key: '요청 목적', value: '일본 시장에서 Enterprise AI·Sovereign AI 공동 사업 가능성을 내부 검토하기 위한 공식 검토 자료 확보' },
        { key: '요청 자료', value: 'MOU 초안, 일본 시장 적용 레퍼런스, 기술 사양서, 보안·데이터 주권 관련 설명자료' },
        { key: '확인 필요', value: '양사 역할 범위, 공동 PoC 추진 방식, 고객 데이터 보관 위치, 컴플라이언스 기준을 문서에 반영해야 합니다.' },
        { key: '권장 처리', value: 'ONECHAMBER에서 표준 MOU 양식과 Sovereign AI 전략 자료를 먼저 찾은 뒤, ONEFFICE에서 회신 가능한 초안 형태로 정리하는 흐름이 적합합니다.' },
      ],
    },
    postSuggestCards: [
      {
        id: 901,
        title: 'ONECHAMBER 자료 찾아보기',
        metaType: null,
        desc: '표준 MOU, 전략 기획서, 기술 사양서를 먼저 탐색합니다.',
        actionLabel: '탐색하기',
        actionStyle: 'solid',
        prompt: '관련 자료를 찾아 MOU 초안을 준비할 수 있는지 확인해줘',
        responseKey: 'mou-search',
      },
      {
        id: 902,
        title: '관련 자료 기반 MOU 준비',
        metaType: null,
        desc: '자료 탐색 후 다음 단계에서 문서 작성을 선택합니다.',
        actionLabel: '준비하기',
        actionStyle: 'outline',
        prompt: '관련 자료를 찾아 MOU 초안을 준비할 수 있는지 확인해줘',
        responseKey: 'mou-search',
      },
      {
        id: 903,
        title: '메일 브리핑 다시 확인',
        metaType: null,
        desc: '현재 메일의 핵심 요청을 다시 확인합니다.',
        actionLabel: '확인하기',
        actionStyle: 'outline',
        prompt: '파트너사 긴급 메일 내용을 먼저 브리핑해줘',
        responseKey: 'mou-mail',
      },
    ],
    nextProActiveCards: INITIAL_PROACTIVE_CARDS,
  },
  'mou-search': {
    streamingTitle: 'ONECHAMBER에서 관련 자료를 탐색 중...',
    doneTitle: 'ONECHAMBER 자료 탐색 완료',
    steps: [
      { label: '메일 요청에서 핵심 키워드를 추출하고 있어요' },
      { label: 'ONECHAMBER에서 관련 자료를 탐색하고 있어요' },
      { label: '문서별 연관도를 평가하고 있어요' },
      { label: '근거 자료를 정리하고 있어요' },
    ],
    stepDur: 720,
    streamingText: 'ONECHAMBER에서 메일의 키워드와 과거 제휴 문서를 연결해 보고 있어요.',
    bubbleText: 'MOU 초안 작성하기, 참고자료 기준으로 조항 구성, 메일 브리핑 다시 보기 3가지를 제안드려요.',
    moduleChips: [
      { label: '[메일 ▶ 요청사항]', iconType: 'bar', done: true },
      { label: '[ONECHAMBER ▶ 관련 자료]', iconType: 'bar', done: true },
    ],
    resultText: 'ONECHAMBER에서 메일 요청과 직접 연결되는 참고자료 3건을 찾았습니다.',
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '',
    insightCard: {
      label: 'AI 인사이트',
      title: 'MOU 초안 작성에 필요한 근거가 확보되었습니다',
      text: '메일의 요청사항과 사내 문서의 의미가 연결되었습니다. 이제 사용자가 다시 자료를 찾지 않아도 AI가 표준 양식, 전략 방향, 일본 시장 요구사항을 조합해 초안 작성을 준비할 수 있습니다.',
    },
    docSearchResult: {
      title: 'ONECHAMBER 연관 자료',
      count: '3건 발견',
      docs: [
        { type: 'ONEX', name: '[템플릿] 글로벌 AI 제휴 표준 MOU 양식.onex', match: '연관 96%', previewIdx: 0 },
        { type: 'PDF', name: '[기획안] 2026 Sovereign AI 비즈니스 전략 기획서.pdf', match: '연관 91%', previewIdx: 1 },
        { type: 'PPTX', name: '[설계서] 일본 시장 로컬라이제이션 기술 사양서.pptx', match: '연관 87%', previewIdx: 2 },
      ],
      judgmentTitle: 'MOU 초안 작성에 필요한 근거 자료가 준비되었습니다',
      judgmentText: '표준 조항은 ONEX 템플릿, 사업 방향은 PDF 기획서, 일본 시장 요구사항은 PPTX 사양서를 근거로 반영하는 흐름이 적합합니다.',
    },
    postSuggestCards: [
      {
        id: 911,
        title: 'MOU 초안 작성하기',
        metaType: null,
        desc: '찾은 3개 자료를 근거로 ONEFFICE 초안을 생성합니다.',
        actionLabel: '작성하기',
        actionStyle: 'solid',
        prompt: '찾은 자료를 바탕으로 MOU 초안을 작성해줘',
        responseKey: 'mou-draft',
      },
      {
        id: 912,
        title: '참고자료 기준으로 조항 구성',
        metaType: null,
        desc: '목적, 협력 범위, 추진 일정 중심으로 문서화합니다.',
        actionLabel: '구성하기',
        actionStyle: 'outline',
        prompt: '찾은 자료를 바탕으로 MOU 초안을 작성해줘',
        responseKey: 'mou-draft',
      },
      {
        id: 913,
        title: '메일 브리핑 다시 보기',
        metaType: null,
        desc: '처음 메일 요약 단계로 돌아갑니다.',
        actionLabel: '확인하기',
        actionStyle: 'outline',
        prompt: '파트너사 긴급 메일 내용을 먼저 브리핑해줘',
        responseKey: 'mou-mail',
      },
    ],
    nextProActiveCards: INITIAL_PROACTIVE_CARDS,
  },
  'mou-draft': {
    streamingTitle: 'MOU 초안 생성 중...',
    doneTitle: 'MOU 초안 생성 완료',
    steps: [
      { label: '선택한 3개 자료의 핵심 조항을 비교하고 있어요' },
      { label: 'MOU 목차와 구조를 구성하고 있어요' },
      { label: '초안 본문을 작성하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '선택된 3개 자료의 핵심 조항을 비교하고 MOU 목차와 초안 구조를 만들고 있어요.',
    bubbleText: '회신 메일 첨부, 일본어 회신 초안, 화상회의 일정 수립 3가지를 다음 단계로 제안드려요.',
    moduleChips: [
      { label: '[메일 ▶ 요청사항]', iconType: 'bar', done: true },
      { label: '[ONECHAMBER ▶ 참고자료 3건]', iconType: 'bar', done: true },
      { label: '[ONEFFICE ▶ MOU 초안]', iconType: 'doc', done: true },
    ],
    resultText: '',
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '',
    insightCard: {
      label: 'AI 인사이트',
      title: 'MOU 초안이 생성되었습니다',
      text: 'ONECHAMBER 참고자료 3건을 기반으로 초안이 작성되었습니다. 조항을 검토한 후 ONEFFICE에서 편집하거나 바로 회신 메일에 첨부할 수 있습니다.',
    },
    postSuggestCards: [
      {
        id: 921,
        title: '회신 메일에 MOU 초안 첨부',
        metaType: null,
        desc: '문서 확인 후 회신 메일에 첨부를 진행합니다.',
        actionLabel: '첨부하기',
        actionStyle: 'solid',
      },
      {
        id: 922,
        title: '일본어 회신 메일 초안',
        metaType: null,
        desc: '타카하시 본부장에게 보낼 정중한 일본어 초안을 작성합니다.',
        actionLabel: '작성하기',
        actionStyle: 'outline',
      },
      {
        id: 923,
        title: '화상회의 일정 수립',
        metaType: null,
        desc: '다음 주 화요일 후보 시간을 확인해 회의 일정을 제안합니다.',
        actionLabel: '일정 잡기',
        actionStyle: 'outline',
      },
    ],
    nextProActiveCards: INITIAL_PROACTIVE_CARDS,
  },
  meeting: {
    steps: [
      { label: '화상회의 일정과 참석자를 확인하고 있어요' },
      { label: '원챔버 회의자료를 검토하고 있어요' },
      { label: '원피스 회의안 보완 항목을 정리하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '화상회의 일정, 원챔버 영업자료, 원피스 회의안, 게시판 공지를 연결해 6월 영업전략 회의 준비 상태를 확인하고 있어요.',
    bubbleText: '의사결정 아젠다 보완, 회의자료 패키지 구성 등 3가지 후속 업무를 제안드려요. 어떤 것부터 시작할까요?',
    moduleChips: [
      { label: '[화상회의 ▶ 6월 영업전략]', iconType: 'bar', done: false },
      { label: '[원챔버 ▶ 영업자료]', iconType: 'doc', done: true },
      { label: '[원피스 ▶ 회의안]', iconType: 'doc', done: true },
    ],
    resultText: '6월 영업전략 회의 업무는 현재 회의 전 준비 단계입니다. 화상회의, 원챔버, 원피스, 게시판 4개 메뉴에서 관련 자료가 감지되었습니다.',
    workflowCards: [
      { title: '화상회의 · 일정', desc: '6월 영업전략 회의가 내일 10:00로 예정되어 있으며 참석자는 영업본부와 마케팅팀 중심입니다.' },
      { title: '원챔버 · 회의자료', desc: '5월 실적 리포트와 6월 파이프라인 현황 파일은 있으나 경쟁사 동향 자료가 아직 첨부되지 않았습니다.' },
      { title: '원피스 · 회의안', desc: '영업전략 회의 아젠다 초안이 작성 중이며, 의사결정 항목 3개가 비어 있습니다.' },
      { title: '게시판 · 사전공지', desc: '회의 참석자 공지는 등록되었지만 사전 질문 수집 댓글에 미답변 2건이 있습니다.' },
    ],
    tableRows: [
      { label: '회의 일정', statusCls: 'stProgress', statusText: '예정됨', judge: '참석자와 시간은 확정됨', action: '자료 연결' },
      { label: '원챔버 자료', statusCls: 'stWarning', statusText: '일부 누락', judge: '경쟁사 동향 자료가 회의 초대에 미첨부', action: '자료 추가' },
      { label: '원피스 회의안', statusCls: 'stWarning', statusText: '작성 중', judge: '의사결정 항목 3개 보완 필요', action: '아젠다 보완' },
      { label: '사전 질문', statusCls: 'stOverdue', statusText: '답변 필요', judge: '댓글 질문 2건이 미답변 상태', action: '답변 후보 작성' },
    ],
    actionItems: [
      { title: '의사결정 아젠다 보완', desc: '원피스 회의안에 결정 필요 항목과 검토 질문을 추가합니다.', score: '지금 실행 가능' },
      { title: '회의자료 패키지 만들기', desc: '5월 실적, 6월 파이프라인, 캠페인 성과 파일을 회의자료로 묶습니다.', score: '지금 실행 가능' },
      { title: '사전 질문 답변 후보 작성', desc: '게시판 댓글 질문 2건에 대한 답변 후보를 생성합니다.', score: '지금 실행 가능' },
    ],
    note: '회의 전에는 원챔버 자료 누락 여부와 원피스 회의안의 의사결정 항목을 먼저 보완하는 것이 좋습니다.',
    postSuggestCards: [
      { id: 201, title: '회의 브리핑 요약문', metaType: null, desc: '참석자에게 공유할 5줄 회의 브리핑과\n핵심 안건을 생성합니다.', actionLabel: '요약문 만들기', actionStyle: 'outline' },
      { id: 202, title: '사전 질문 답변 후보', metaType: null, desc: '게시판 댓글과 사전 질문에 대한\n답변 후보를 준비합니다.', actionLabel: '답변 보기', actionStyle: 'outline' },
      { id: 203, title: '회의자료 자동 첨부', metaType: null, desc: '원챔버 영업자료와 원피스 회의안을\n화상회의에 첨부합니다.', actionLabel: '첨부하기', actionStyle: 'solid' },
    ],
    nextProActiveCards: [
      { id: 'pkg', title: '6월 영업 회의자료 패키지', metaType: 'warn', metaText: '자료 3종 중 1종 누락', desc: '5월 실적, 6월 파이프라인, 캠페인 성과를 묶고\n누락된 경쟁사 동향 자료를 추가 제안합니다.', actionLabel: '자료 묶기', actionStyle: 'solid', prompt: '6월 영업전략 회의자료 패키지를 만들고 누락 자료를 알려줘' },
      { id: 'agenda', title: '의사결정 아젠다 초안', metaType: 'date', metaText: '회의 전일 2026.06.01', desc: '안건별 결정 사항과 필요 데이터를 정리해\n회의 진행용 아젠다 초안을 작성합니다.', actionLabel: '초안 생성', actionStyle: 'outline', prompt: '6월 영업전략 회의 의사결정 아젠다 초안을 작성해줘' },
      { id: 'competitor', title: '경쟁사 동향 자료 수집', metaType: 'warn', metaText: '누락 항목 확인 필요', desc: '최신 경쟁사 동향과 시장 분석을 수집해\n회의 자료에 추가할 수 있도록 정리합니다.', actionLabel: '자료 수집', actionStyle: 'outline', prompt: '6월 영업전략 회의용 경쟁사 동향 자료를 수집하고 요약해줘' },
    ],
  },
  followup: {
    steps: [
      { label: '게시판 회람 현황을 확인하고 있어요' },
      { label: '원챔버 첨부파일 버전을 대조하고 있어요' },
      { label: '설명회 자료 패키지를 구성하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '게시판, 원챔버, 원피스, 화상회의 자료를 연결해 하계 유연근무제 안내 흐름을 확인하고 있어요.',
    bubbleText: '미확인자 알림, 최신 파일 비교, 설명회 자료 패키지 3가지를 제안드려요. 어떤 것부터 시작할까요?',
    moduleChips: [
      { label: '[게시판 ▶ 회람 현황]', iconType: 'bar', done: false },
      { label: '[원챔버 ▶ 세부지침 PDF]', iconType: 'doc', done: true },
      { label: '[원피스 ▶ 운영 가이드]', iconType: 'doc', done: true },
    ],
    resultText: '하계 유연근무제 안내 업무는 현재 공지 후 확인 대기 단계입니다. 게시판, 원챔버, 원피스, 화상회의 4개 메뉴에서 관련 자료가 감지되었습니다.',
    workflowCards: [
      { title: '게시판 · 회람', desc: '근무시간 변경 안내 게시글이 회람 진행 중입니다. 10명 중 7명 확인, 미확인 3명입니다.' },
      { title: '원챔버 · 첨부파일', desc: '유연근무제_세부지침.pdf가 게시글 등록 이후 수정되었습니다. 최신본 반영 여부 확인이 필요합니다.' },
      { title: '원피스 · 운영 가이드', desc: '인사팀이 하계 유연근무제 운영 가이드 초안을 공동 편집 중입니다.' },
      { title: '화상회의 · 설명회', desc: '오늘 15:00 인사팀 설명회가 예정되어 있으며, 관련 자료 패키지를 자동 구성할 수 있습니다.' },
    ],
    tableRows: [
      { label: '게시판 회람', statusCls: 'stWarning', statusText: '진행 중', judge: '미확인자 3명 잔여', action: '알림 문구 작성' },
      { label: '첨부파일 버전', statusCls: 'stOverdue', statusText: '확인 필요', judge: '파일 수정 감지됨', action: '버전 비교' },
      { label: '원피스 가이드', statusCls: 'stProgress', statusText: '작성 중', judge: '문서 연결 가능', action: '관련 문서 연결' },
      { label: '설명회 준비', statusCls: 'stProgress', statusText: '준비 가능', judge: '자료 패키지 생성 가능', action: '자료 묶기' },
    ],
    actionItems: [
      { title: '미확인자에게 알림 보내기', desc: '게시판 회람 대상 중 미확인자 3명에게 보낼 문구를 생성합니다.', score: '지금 실행 가능' },
      { title: '원챔버 최신 파일과 게시글 첨부 비교', desc: '세부지침 PDF의 수정일과 게시글 첨부 버전을 대조합니다.', score: '지금 실행 가능' },
      { title: '설명회 자료 패키지 만들기', desc: '원챔버 파일, 원피스 가이드, 게시판 FAQ를 회의자료로 묶습니다.', score: '지금 실행 가능' },
    ],
    note: '추천 조치를 선택하면 해당 메뉴로 이동해 실행할 수 있어요. 먼저 첨부파일 버전 확인을 권장합니다.',
    postSuggestCards: [
      { id: 211, title: '직원 공유용 요약문', metaType: null, desc: '공지와 세부지침을 바탕으로\n5줄 요약과 Q&A를 생성합니다.', actionLabel: '요약문 만들기', actionStyle: 'outline' },
      { id: 212, title: '댓글 답변 후보', metaType: null, desc: '신청 방법과 출근 시간 기준 관련\n댓글에 답변 후보를 제안합니다.', actionLabel: '답변 보기', actionStyle: 'outline' },
      { id: 213, title: '회의자료 자동 첨부', metaType: null, desc: '설명회 일정에 맞춰 원챔버 파일과\n원피스 가이드를 자동 첨부합니다.', actionLabel: '첨부하기', actionStyle: 'solid' },
    ],
    nextProActiveCards: [
      { id: 'summary', title: '직원 공유용 요약문', metaType: 'date', metaText: '설명회 오늘 15:00', desc: '공지와 세부지침을 바탕으로\n5줄 요약과 Q&A를 생성합니다.', actionLabel: '초안 생성 승인', actionStyle: 'outline', prompt: '하계 유연근무제 직원 공유용 요약문과 Q&A를 작성해줘' },
      { id: 'comment', title: '댓글 답변 후보', metaType: 'date', metaText: '댓글 문의 3건 대기', desc: '신청 방법과 출근 시간 기준 관련\n댓글에 답변 후보를 제안합니다.', actionLabel: '답변 후보 검토', actionStyle: 'outline', prompt: '하계 유연근무제 댓글 답변 후보를 작성해줘' },
      { id: 'attach', title: '회의자료 자동 첨부', metaType: 'date', metaText: '설명회 오늘 15:00', desc: '설명회 일정에 맞춰 원챔버 파일과\n원피스 가이드를 자동 첨부합니다.', actionLabel: '자동 첨부 승인', actionStyle: 'solid', prompt: '하계 유연근무제 설명회 자료를 자동 첨부하고 확인 항목을 정리해줘' },
    ],
  },
  circular: {
    steps: [
      { label: '게시판 공지 회람 상태를 확인하고 있어요' },
      { label: '원챔버 개정본 파일을 검토하고 있어요' },
      { label: '반복 문의에 대한 FAQ를 정리하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '게시판 공지, 원챔버 개정본, 원피스 비교표, 메신저 문의를 연결해 법인카드 규정 개정 흐름을 확인하고 있어요.',
    bubbleText: '변경 전후 비교표 생성, 증빙 기준 FAQ 작성 등 3가지 후속 업무를 제안드려요. 어떤 것부터 시작할까요?',
    moduleChips: [
      { label: '[게시판 ▶ 법인카드 공지]', iconType: 'bar', done: false },
      { label: '[원챔버 ▶ 개정본 PDF]', iconType: 'doc', done: true },
      { label: '[원피스 ▶ 변경 비교표]', iconType: 'doc', done: true },
    ],
    resultText: '법인카드 사용 규정 개정 업무는 현재 공지 후 검토 필요 단계입니다. 게시판, 원챔버, 원피스, 메신저 4개 메뉴에서 관련 자료가 감지되었습니다.',
    workflowCards: [
      { title: '게시판 · 개정 공지', desc: '법인카드 사용 규정 개정 안내가 회람 중이며, 일부 부서 확인이 지연되고 있습니다.' },
      { title: '원챔버 · 개정본', desc: '법인카드_사용규정_개정본.pdf와 비용정산_증빙가이드.xlsx가 등록되어 있습니다.' },
      { title: '원피스 · 비교표', desc: '변경 전후 비교표 초안이 작성되었지만 예외 승인 절차 항목이 비어 있습니다.' },
      { title: '메신저 · 문의', desc: '영업팀과 총무팀 대화에서 증빙 제출 기준 관련 문의가 반복 감지되었습니다.' },
    ],
    tableRows: [
      { label: '개정 공지', statusCls: 'stWarning', statusText: '회람 중', judge: '확인 지연 부서가 있어 추가 안내 필요', action: '부서 알림' },
      { label: '개정본 파일', statusCls: 'stProgress', statusText: '등록됨', judge: '원챔버 최신 파일 기준으로 안내 가능', action: '게시글 연결' },
      { label: '변경 비교표', statusCls: 'stWarning', statusText: '보완 필요', judge: '예외 승인 절차 설명이 부족함', action: '비교표 보완' },
      { label: '반복 문의', statusCls: 'stOverdue', statusText: '답변 필요', judge: '증빙 제출 기준 문의가 반복됨', action: 'FAQ 작성' },
    ],
    actionItems: [
      { title: '변경 전후 비교표 생성', desc: '개정본 PDF와 이전 규정을 비교해 직원용 표로 정리합니다.', score: '지금 실행 가능' },
      { title: '증빙 기준 FAQ 작성', desc: '메신저와 게시판 문의를 바탕으로 자주 묻는 질문 답변을 만듭니다.', score: '지금 실행 가능' },
      { title: '개정본 파일 연결 점검', desc: '게시판 공지와 원챔버 최신 개정본이 같은 버전인지 확인합니다.', score: '지금 실행 가능' },
    ],
    note: '개정 공지는 변경 전후 비교표와 최신 개정본을 함께 연결해야 혼선을 줄일 수 있습니다.',
    postSuggestCards: [
      { id: 221, title: '직원 안내 요약문', metaType: null, desc: '개정 사유, 주요 변경사항, 적용일을\n직원 공유용으로 정리합니다.', actionLabel: '요약문 만들기', actionStyle: 'outline' },
      { id: 222, title: '메신저 답변 초안 생성', metaType: null, desc: '반복 문의된 증빙 제출 기준에 대한\n메신저 답변 초안을 생성합니다.', actionLabel: '초안 보기', actionStyle: 'outline' },
      { id: 223, title: '개정본 자동 첨부', metaType: null, desc: '게시판 공지와 원챔버 최신 개정본,\n변경 비교표를 함께 연결합니다.', actionLabel: '첨부하기', actionStyle: 'solid' },
    ],
    nextProActiveCards: [
      { id: 'resend', title: '회람 재발송 대상 알림', metaType: 'warn', metaText: '미확인 4명', desc: '회람을 아직 확인하지 않은 4명에게\n재발송 알림 문구를 작성합니다.', actionLabel: '알림 발송 승인', actionStyle: 'solid', prompt: '법인카드 규정 개정 회람 미확인자에게 재발송 알림 문구를 작성해줘' },
      { id: 'qa', title: 'Q&A 답변 후보 생성', metaType: 'warn', metaText: '예상 문의: 영수증 제출 기한', desc: '규정 변경 이후 자주 나올 질문을 기준으로\n게시판 댓글 답변 후보를 준비합니다.', actionLabel: '답변 생성', actionStyle: 'outline', prompt: '법인카드 규정 개정 관련 Q&A 답변 후보를 작성해줘' },
      { id: 'guide', title: '개정 규정 요약 안내문', metaType: 'date', metaText: '기한 변경 내용 포함', desc: '영수증 제출 기한 변경 등 핵심 내용을\n직원 안내문 형식으로 정리합니다.', actionLabel: '안내문 생성', actionStyle: 'outline', prompt: '법인카드 규정 개정 내용을 직원 안내문 형식으로 정리해줘' },
    ],
  },
  'lease-journal': {
    steps: [
      { label: 'ERP 회계에서 리스 계약 정보를 확인하고 있어요' },
      { label: '회계 처리 방식과 이율을 검토하고 있어요' },
      { label: '분개 항목을 생성하고 있어요' },
    ],
    stepDur: 960,
    streamingText: 'ERP 회계 시스템에서 복합기 리스 계약 정보와 회계 처리 방식을 확인해 분개를 생성하고 있어요.',
    bubbleText: '생성된 분개를 확인한 후 전표로 전송해주세요. 추가 조회가 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 리스 계약]', iconType: 'bar', done: false },
      { label: '[ERP 회계 ▶ 분개 생성]', iconType: 'doc', done: true },
    ],
    resultText: '선택된 내용으로 분개를 생성하였습니다. 생성된 분개를 확인한 후 전표로 전송해주세요.',
    leaseInfo: [
      { label: '리스료', value: '16,900 JPY', note: '부가세 별도' },
      { label: '리스 대상 금액', value: '907,700 JPY' },
      { label: '이율', value: '1.86%' },
      { label: '회계 처리 방식', value: '원칙법' },
      { label: '계약기간', value: '2026-06-01 ~ 2031-05-31' },
      { label: '계약 종류', value: '금융리스' },
      { label: '리스회사', value: '株式会社 大塚商会' },
      { label: '결제 수단', value: '자동 이체' },
    ],
    journalEntry: {
      date: '2026-06-30',
      category: '매입세금',
      party: '株式会社 大塚商会',
      desc: '복합기 리스료',
      amount: '18,590',
      taxRate: '10%',
      taxAmt: '1,690',
      attachment: '리스 계약서.PNG',
      actionLabel: '전표 반영',
      rows: [
        { type: '차변', account: '리스채무',  debit: '16,720', credit: '-',      taxRate: '10%', taxAmt: '1,520', party: '株式会社 大塚商会', desc: '복합기 리스료' },
        { type: '차변', account: '이자비용',  debit: '1,870',  credit: '-',      taxRate: '10%', taxAmt: '170',   party: '株式会社 大塚商会', desc: '복합기 리스료' },
        { type: '대변', account: '보통예금',  debit: '-',      credit: '18,590', taxRate: '-',   taxAmt: '-',     party: 'Mizho銀行',         desc: '복합기 리스료' },
      ],
      totals: { debit: '18,590', credit: '18,590', taxAmt: '1,690' },
    },
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '',
    postSuggestCards: [
      { id: 401, title: '남은 리스료 계산', metaType: null, desc: '계약 종료까지 남은 리스료를\n계산합니다.', actionLabel: '계산하기', actionStyle: 'outline', prompt: '남은 리스료를 계산해줘', responseKey: 'lease-remaining' },
      { id: 402, title: '총 지급액 계산', metaType: null, desc: '계약 종료까지 총 지급액을\n계산합니다.', actionLabel: '계산하기', actionStyle: 'solid', prompt: '계약 종료까지 총 지급액을 계산해줘', responseKey: 'lease-total-payment' },
      { id: 403, title: '다음 분개 진행', metaType: null, desc: '준비된 다음 분개를 확인합니다.', actionLabel: '진행하기', actionStyle: 'solid', prompt: '이메일 첨부파일을 확인하여 증빙 여부를 판단하고, 증빙인 경우 전표를 생성해 주세요.', responseKey: 'invoice-journal' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  'lease-remaining': {
    streamingTitle: '남은 리스료 계산 중...',
    doneTitle: '남은 리스료 계산 완료',
    steps: [
      { label: 'ERP 회계에서 리스 계약 정보를 확인하고 있어요' },
      { label: '납부 완료 회차와 남은 개월 수를 계산하고 있어요' },
      { label: '남은 리스료를 산출하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 회계 시스템에서 복합기 리스 계약 정보를 조회해 남은 리스료를 계산하고 있어요.',
    bubbleText: '남은 리스료 계산이 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 리스 계약]', iconType: 'bar', done: true },
    ],
    resultText: '계약 종료일(2031-05-31)까지 남은 59개월 기준으로 남은 리스료를 계산하였습니다.',
    leaseInfoTitle: '남은 리스료 계산 결과',
    leaseInfoBtnLabel: '상환 스케줄 확인',
    leaseInfo: [
      { label: '남은 리스료', value: '997,100 JPY', note: '부가세 별도 · 59개월 × 16,900 JPY' },
      { label: '남은 개월 수', value: '59개월' },
      { label: '월 리스료', value: '16,900 JPY' },
      { label: '계약 종료일', value: '2031-05-31' },
      { label: '리스 대상 금액', value: '907,700 JPY' },
      { label: '이율', value: '1.86%' },
      { label: '회계 처리 방식', value: '원칙법' },
      { label: '리스회사', value: '株式会社 大塚商会' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '2026년 6월분 리스료는 납부가 완료되어 계산에서 제외했습니다.',
    postSuggestCards: [
      { id: 411, title: '총 지급액 계산', metaType: null, desc: '부가세를 포함한 계약 종료까지의\n총 지급액을 계산합니다.', actionLabel: '계산하기', actionStyle: 'solid', prompt: '계약 종료까지 총 지급액을 계산해줘', responseKey: 'lease-total-payment' },
      { id: 412, title: '리스 스케줄 확인', metaType: 'date', metaDate: '2026.06.30 (화)', desc: '남은 리스 기간 동안의 상환 스케줄과\n이자 비용을 확인합니다.', actionLabel: '스케줄 보기', actionStyle: 'outline' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  'lease-total-payment': {
    streamingTitle: '총 지급액 계산 중...',
    doneTitle: '총 지급액 계산 완료',
    steps: [
      { label: 'ERP 회계에서 리스 계약 정보를 확인하고 있어요' },
      { label: '남은 개월 수와 부가세를 반영해 계산하고 있어요' },
      { label: '계약 종료까지 총 지급액을 산출하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 회계 시스템에서 복합기 리스 계약 정보를 조회해 부가세 포함 총 지급액을 계산하고 있어요.',
    bubbleText: '총 지급액 계산이 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 리스 계약]', iconType: 'bar', done: true },
    ],
    resultText: '계약 종료일(2031-05-31)까지 남은 59개월 기준으로 부가세 포함 총 지급액을 계산하였습니다.',
    leaseInfoTitle: '계약 종료까지 총 지급액',
    leaseInfoBtnLabel: '상환 스케줄 확인',
    leaseInfo: [
      { label: '총 지급액', value: '1,096,810 JPY', note: '부가세 포함 · 59개월 × 18,590 JPY' },
      { label: '남은 개월 수', value: '59개월' },
      { label: '월 납부액(부가세 포함)', value: '18,590 JPY' },
      { label: '계약 종료일', value: '2031-05-31' },
      { label: '리스 대상 금액', value: '907,700 JPY' },
      { label: '이율', value: '1.86%' },
      { label: '회계 처리 방식', value: '원칙법' },
      { label: '리스회사', value: '株式会社 大塚商会' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '2026년 6월분 리스료는 납부가 완료되어 계산에서 제외했습니다.',
    postSuggestCards: [
      { id: 421, title: '남은 리스료 계산', metaType: null, desc: '부가세 별도 기준\n남은 리스료를 계산합니다.', actionLabel: '계산하기', actionStyle: 'outline', prompt: '남은 리스료를 계산해줘', responseKey: 'lease-remaining' },
      { id: 422, title: '리스 스케줄 확인', metaType: 'date', metaDate: '2026.06.30 (화)', desc: '남은 리스 기간 동안의 상환 스케줄과\n이자 비용을 확인합니다.', actionLabel: '스케줄 보기', actionStyle: 'outline' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  'invoice-journal': {
    steps: [
      { label: '메일 첨부 파일에서 청구서를 확인하고 있어요' },
      { label: '인보이스 항목과 금액을 분석하고 있어요' },
      { label: '전표 분개를 생성하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '株式会社ニトリ에서 수신한 청구서를 분석해 전표 분개를 생성하고 있어요.',
    bubbleText: '생성된 전표를 확인한 후 ERP에 반영해주세요. 추가 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[메일 ▶ ニトリ 청구서]', iconType: 'bar', done: false },
      { label: '[ERP 회계 ▶ 전표 생성]', iconType: 'doc', done: true },
    ],
    resultText: '株式会社ニトリ 청구서를 분석하여 전표를 생성하였습니다. 내용을 확인한 후 전표로 반영해주세요.',
    transactionInfoBtnLabel: '청구서 원본 확인',
    transactionInfo: [
      { label: '청구 금액', value: '105,600 JPY', note: '세금 포함' },
      { label: '공급가액', value: '96,000 JPY' },
      { label: '소비세(10%)', value: '9,600 JPY' },
      { label: '청구일', value: '2026-06-25' },
      { label: '청구서 번호', value: 'NTR-2026-06-1245' },
      { label: '지급기한', value: '2026-07-25' },
      { label: '거래처', value: '株式会社ニトリ' },
      { label: '지급 방법', value: '은행 이체' },
    ],
    journalEntry: {
      date: '2026-06-30',
      category: '매입',
      party: '株式会社ニトリ',
      desc: '사무용 가구 일식',
      amount: '96,000',
      taxRate: '10%',
      taxAmt: '9,600',
      attachment: 'ニトリ_청구서_NTR-2026-06-1245.PDF',
      actionLabel: '전표 반영',
      rows: [
        { type: '차변', account: '소모품비', debit: '96,000', credit: '-', taxRate: '10%', taxAmt: '9,600', party: '株式会社ニトリ', desc: '사무용 가구 일식' },
        { type: '차변', account: '가수금(소비세)', debit: '9,600', credit: '-', taxRate: '-', taxAmt: '-', party: '株式会社ニトリ', desc: '소비세 10%' },
        { type: '대변', account: '미지급금', debit: '-', credit: '105,600', taxRate: '-', taxAmt: '-', party: '株式会社ニトリ', desc: '사무용 가구 일식' },
      ],
      totals: { debit: '105,600', credit: '105,600', taxAmt: '9,600' },
    },
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '청구서 원본이 메일에 첨부되어 있습니다. 전표 반영 전 금액과 품목을 최종 확인해주세요.',
    postSuggestCards: [
      { id: 501, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 이 거래처와의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 이 거래처와의 거래 내역을 알려줘', responseKey: 'invoice-history' },
      { id: 502, title: '지출 결의서 작성', metaType: null, desc: '이 인보이스를 근거로\n지출 결의서를 작성합니다.', actionLabel: '작성하기', actionStyle: 'solid', prompt: '이 인보이스로 지출 결의서를 작성해줘', responseKey: 'invoice-expense-request' },
      { id: 503, title: '미지급 잔액 확인', metaType: null, desc: '이 거래처의 미지급\n잔액을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '이 거래처의 미지급 잔액을 알려줘', responseKey: 'invoice-payable-balance' },
    ],
    nextProActiveCards: [
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
      { id: 'lease-journal', title: '리스료 전표 반영', metaType: 'none', metaText: '', desc: '복합기 리스에 대한 분개를 생성하였습니다.\n분개를 확인후 전표로 반영해주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '오늘 납부할 리스료가 있는지 확인하고 회계 처리 방식에 맞춰서 분개를 만들어줘' },
    ],
  },
  'invoice-history': {
    streamingTitle: '거래 내역 조회 중...',
    doneTitle: '최근 6개월 거래 내역 조회 완료',
    steps: [
      { label: 'ERP 회계에서 거래처 정보를 확인하고 있어요' },
      { label: '최근 6개월 거래 내역을 조회하고 있어요' },
      { label: '월별 청구 금액을 정리하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 회계 시스템에서 株式会社ニトリ와의 최근 6개월 거래 내역을 조회하고 있어요.',
    bubbleText: '최근 6개월 거래 내역 조회가 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 거래 내역]', iconType: 'bar', done: true },
    ],
    resultText: '최근 6개월(2026.01~2026.06)간 株式会社ニトリ와의 거래 내역을 조회했습니다. 총 6건, 612,300 JPY 규모입니다.',
    leaseInfoTitle: '株式会社ニトリ 최근 6개월 거래 내역',
    leaseInfoBtnLabel: '거래 내역 상세 보기',
    leaseInfo: [
      { label: '6개월 총 거래 금액', value: '612,300 JPY', note: '2026.01~2026.06 · 6건' },
      { label: '월 평균 청구 금액', value: '102,050 JPY' },
      { label: '2026-01 청구액', value: '89,100 JPY' },
      { label: '2026-02 청구액', value: '97,200 JPY' },
      { label: '2026-03 청구액', value: '92,400 JPY' },
      { label: '2026-04 청구액', value: '110,000 JPY' },
      { label: '2026-05 청구액', value: '118,000 JPY' },
      { label: '2026-06 청구액', value: '105,600 JPY' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '2026-06 청구건(NTR-2026-06-1245)이 최근 거래 내역입니다.',
    postSuggestCards: [
      { id: 511, title: '지출 결의서 작성', metaType: null, desc: '최근 인보이스를 근거로\n지출 결의서를 작성합니다.', actionLabel: '작성하기', actionStyle: 'solid', prompt: '이 인보이스로 지출 결의서를 작성해줘', responseKey: 'invoice-expense-request' },
      { id: 512, title: '미지급 잔액 확인', metaType: null, desc: '이 거래처의 미지급\n잔액을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '이 거래처의 미지급 잔액을 알려줘', responseKey: 'invoice-payable-balance' },
    ],
    nextProActiveCards: [
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
      { id: 'lease-journal', title: '리스료 전표 반영', metaType: 'none', metaText: '', desc: '복합기 리스에 대한 분개를 생성하였습니다.\n분개를 확인후 전표로 반영해주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '오늘 납부할 리스료가 있는지 확인하고 회계 처리 방식에 맞춰서 분개를 만들어줘' },
    ],
  },
  'invoice-expense-request': {
    streamingTitle: '지출 결의서 작성 중...',
    doneTitle: '지출 결의서 작성 완료',
    steps: [
      { label: '인보이스 항목과 금액을 확인하고 있어요' },
      { label: '지출 결의서 양식에 항목을 매핑하고 있어요' },
      { label: '결재 요청 초안을 정리하고 있어요' },
    ],
    stepDur: 800,
    streamingText: '株式会社ニトリ 청구서를 근거로 지출 결의서 초안을 작성하고 있어요.',
    bubbleText: '지출 결의서 초안 작성이 완료되었습니다. 결재 요청 전 내용을 확인해주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 지출 결의서]', iconType: 'doc', done: true },
    ],
    resultText: '株式会社ニトリ 청구서(NTR-2026-06-1245)를 근거로 지출 결의서 초안을 작성하였습니다. 결재 요청 전 금액과 항목을 확인해주세요.',
    leaseInfoTitle: '지출 결의서 초안',
    leaseInfoBtnLabel: '결의서 확인',
    leaseInfo: [
      { label: '지출 금액', value: '105,600 JPY', note: '세금 포함 · EXP-2026-06-0142' },
      { label: '결의서 번호', value: 'EXP-2026-06-0142' },
      { label: '거래처', value: '株式会社ニトリ' },
      { label: '지출 항목', value: '사무용 가구 일식' },
      { label: '기안일', value: '2026-06-30' },
      { label: '결재 상태', value: '결재 대기' },
      { label: '근거 자료', value: '청구서 NTR-2026-06-1245' },
      { label: '지급 예정일', value: '2026-07-25' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '결재 완료 후 ERP 회계 전표와 자동 연동됩니다.',
    postSuggestCards: [
      { id: 521, title: '미지급 잔액 확인', metaType: null, desc: '이 거래처의 미지급\n잔액을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '이 거래처의 미지급 잔액을 알려줘', responseKey: 'invoice-payable-balance' },
      { id: 522, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 이 거래처와의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 이 거래처와의 거래 내역을 알려줘', responseKey: 'invoice-history' },
    ],
    nextProActiveCards: [
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
      { id: 'lease-journal', title: '리스료 전표 반영', metaType: 'none', metaText: '', desc: '복합기 리스에 대한 분개를 생성하였습니다.\n분개를 확인후 전표로 반영해주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '오늘 납부할 리스료가 있는지 확인하고 회계 처리 방식에 맞춰서 분개를 만들어줘' },
    ],
  },
  'invoice-payable-balance': {
    streamingTitle: '미지급 잔액 확인 중...',
    doneTitle: '미지급 잔액 확인 완료',
    steps: [
      { label: 'ERP 회계에서 거래처 미지급 내역을 확인하고 있어요' },
      { label: '지급기한과 잔액을 계산하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 회계 시스템에서 株式会社ニトリ의 미지급 잔액을 확인하고 있어요.',
    bubbleText: '미지급 잔액 확인이 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 미지급 내역]', iconType: 'bar', done: true },
    ],
    resultText: '株式会社ニトリ와의 거래 중 현재 미지급 상태인 청구서는 1건, 총 105,600 JPY입니다.',
    leaseInfoTitle: '株式会社ニトリ 미지급 잔액',
    leaseInfoBtnLabel: '미지급 내역 상세 보기',
    leaseInfo: [
      { label: '미지급 잔액', value: '105,600 JPY', note: '세금 포함 · 1건' },
      { label: '지급기한', value: '2026-07-25' },
      { label: '청구서 번호', value: 'NTR-2026-06-1245' },
      { label: '거래처', value: '株式会社ニトリ' },
      { label: '공급가액', value: '96,000 JPY' },
      { label: '소비세(10%)', value: '9,600 JPY' },
      { label: '지급 방법', value: '은행 이체' },
      { label: '최근 결제 완료일', value: '2026-05-28' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '지급기한(2026-07-25) 이전에 결제 처리를 완료해주세요.',
    postSuggestCards: [
      { id: 531, title: '지출 결의서 작성', metaType: null, desc: '미지급 청구서를 근거로\n지출 결의서를 작성합니다.', actionLabel: '작성하기', actionStyle: 'solid', prompt: '이 인보이스로 지출 결의서를 작성해줘', responseKey: 'invoice-expense-request' },
      { id: 532, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 이 거래처와의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 이 거래처와의 거래 내역을 알려줘', responseKey: 'invoice-history' },
    ],
    nextProActiveCards: [
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
      { id: 'lease-journal', title: '리스료 전표 반영', metaType: 'none', metaText: '', desc: '복합기 리스에 대한 분개를 생성하였습니다.\n분개를 확인후 전표로 반영해주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '오늘 납부할 리스료가 있는지 확인하고 회계 처리 방식에 맞춰서 분개를 만들어줘' },
    ],
  },
  'evidence-mapping': {
    streamingTitle: '증빙 파일 매핑 확인 중...',
    doneTitle: '증빙 파일 전표 매핑 완료',
    steps: [
      { label: '제노랩 증빙 파일을 확인하고 있어요' },
      { label: '계정과목과 금액을 분석하고 있어요' },
      { label: '전표 매핑 내역을 생성하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '제노랩(수임기업)이 제출한 증빙 파일을 확인하고 복리후생비 전표로 자동 매핑하고 있어요.',
    bubbleText: '전표 매핑 확인이 완료되었습니다. 추가로 필요한 내용이 있으면 말씀해 주세요.',
    moduleChips: [
      { label: '[증빙 확인 ▶ 제노랩 매핑]', iconType: 'bar', done: false },
      { label: '[ERP 세무 ▶ 전표 생성]', iconType: 'doc', done: true },
    ],
    resultText: '제노랩이 제출한 증빙 파일 3건을 확인하여 복리후생비 전표로 자동 매핑하였습니다. 매핑 내용을 확인한 후 전표로 반영해주세요.',
    transactionInfoBtnLabel: '증빙 파일 원본 확인',
    transactionInfo: [
      { label: '매핑 금액', value: '245,000 JPY', note: '세금 포함' },
      { label: '공급가액', value: '222,727 JPY' },
      { label: '소비세(10%)', value: '22,273 JPY' },
      { label: '증빙 건수', value: '3건' },
      { label: '매핑일', value: '2026-06-28' },
      { label: '수임기업', value: '제노랩' },
      { label: '계정 과목', value: '복리후생비' },
      { label: '제출 방식', value: 'ERP 세무 자동 수신' },
    ],
    journalEntry: {
      date: '2026-06-28',
      category: '복리후생비',
      party: '제노랩(수임기업)',
      desc: '복리후생비 증빙 3건 자동 매핑',
      amount: '222,727',
      taxRate: '10%',
      taxAmt: '22,273',
      attachment: '제노랩_증빙_3건.zip',
      actionLabel: '전표 반영',
      rows: [
        { type: '차변', account: '복리후생비', debit: '222,727', credit: '-', taxRate: '10%', taxAmt: '22,273', party: '제노랩(수임기업)', desc: '회식비 등 3건' },
        { type: '차변', account: '가수금(소비세)', debit: '22,273', credit: '-', taxRate: '-', taxAmt: '-', party: '제노랩(수임기업)', desc: '소비세 10%' },
        { type: '대변', account: '미지급금', debit: '-', credit: '245,000', taxRate: '-', taxAmt: '-', party: '제노랩(수임기업)', desc: '증빙 매핑 합계' },
      ],
      totals: { debit: '245,000', credit: '245,000', taxAmt: '22,273' },
    },
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '증빙 파일 원본이 첨부되어 있습니다. 전표 반영 전 계정과목과 금액을 최종 확인해주세요.',
    postSuggestCards: [
      { id: 701, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 제노랩과의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 거래처의 거래 내역을 알려줘', responseKey: 'genolab-history' },
      { id: 702, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
      { id: 703, title: '중복 거래 확인', metaType: null, desc: '동일한 거래가 중복으로\n입력되었는지 확인합니다.', actionLabel: '확인하기', actionStyle: 'solid', prompt: '동일한 거래가 중복으로 입력되었는지 확인해줘', responseKey: 'duplicate-check' },
    ],
    nextProActiveCards: [
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
      { id: 'invoice-journal', title: '인보이스 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '株式会社ニトリ에서 전송한청구서로 전표를 생성하였습니다.\n생성된 전표를 확인해주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '이메일 첨부파일을 확인하여 증빙 여부를 판단하고, 증빙인 경우 전표를 생성해 주세요.' },
    ],
  },
  'genolab-history': {
    streamingTitle: '거래 내역 조회 중...',
    doneTitle: '최근 6개월 거래 내역 조회 완료',
    steps: [
      { label: 'ERP 세무에서 거래처 정보를 확인하고 있어요' },
      { label: '최근 6개월 거래 내역을 조회하고 있어요' },
      { label: '월별 거래 금액을 정리하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 세무 시스템에서 제노랩과의 최근 6개월 거래 내역을 조회하고 있어요.',
    bubbleText: '최근 6개월 거래 내역 조회가 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 세무 ▶ 거래 내역]', iconType: 'bar', done: true },
    ],
    resultText: '최근 6개월(2026.01~2026.06)간 제노랩과의 거래 내역을 조회했습니다. 총 18건, 1,486,000 JPY 규모입니다.',
    leaseInfoTitle: '제노랩 최근 6개월 거래 내역',
    leaseInfoBtnLabel: '거래 내역 상세 보기',
    leaseInfo: [
      { label: '6개월 총 거래 금액', value: '1,486,000 JPY', note: '2026.01~2026.06 · 18건' },
      { label: '월 평균 거래 금액', value: '247,667 JPY' },
      { label: '2026-01 거래액', value: '210,000 JPY' },
      { label: '2026-02 거래액', value: '185,000 JPY' },
      { label: '2026-03 거래액', value: '260,000 JPY' },
      { label: '2026-04 거래액', value: '298,000 JPY' },
      { label: '2026-05 거래액', value: '288,000 JPY' },
      { label: '2026-06 거래액', value: '245,000 JPY' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '2026-06 거래에는 이번에 매핑된 복리후생비 증빙 3건(245,000 JPY)이 포함되어 있습니다.',
    postSuggestCards: [
      { id: 711, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
      { id: 712, title: '중복 거래 확인', metaType: null, desc: '동일한 거래가 중복으로\n입력되었는지 확인합니다.', actionLabel: '확인하기', actionStyle: 'solid', prompt: '동일한 거래가 중복으로 입력되었는지 확인해줘', responseKey: 'duplicate-check' },
    ],
    nextProActiveCards: [
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
      { id: 'invoice-journal', title: '인보이스 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '株式会社ニトリ에서 전송한청구서로 전표를 생성하였습니다.\n생성된 전표를 확인해주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '이메일 첨부파일을 확인하여 증빙 여부를 판단하고, 증빙인 경우 전표를 생성해 주세요.' },
    ],
  },
  'welfare-expense-trend': {
    streamingTitle: '복리후생비 지출 현황 확인 중...',
    doneTitle: '복리후생비 지출 현황 확인 완료',
    steps: [
      { label: 'ERP 세무에서 복리후생비 계정을 조회하고 있어요' },
      { label: '최근 6개월 지출 내역을 집계하고 있어요' },
      { label: '전월 대비 증감을 분석하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 세무 시스템에서 최근 6개월 복리후생비 지출 현황을 집계하고 있어요.',
    bubbleText: '복리후생비 지출 현황 확인이 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 세무 ▶ 복리후생비 조회]', iconType: 'bar', done: true },
    ],
    resultText: '최근 6개월(2026.01~2026.06)간 복리후생비 지출 현황을 조회했습니다. 총 892,000 JPY이며, 6월 지출이 전월 대비 88.5% 증가했습니다.',
    leaseInfoTitle: '최근 6개월 복리후생비 지출 현황',
    leaseInfoBtnLabel: '지출 내역 상세 보기',
    leaseInfo: [
      { label: '6개월 총 복리후생비', value: '892,000 JPY', note: '2026.01~2026.06 · 전월比 +88.5%' },
      { label: '월 평균 지출액', value: '148,667 JPY' },
      { label: '2026-01 지출액', value: '120,000 JPY' },
      { label: '2026-02 지출액', value: '95,000 JPY' },
      { label: '2026-03 지출액', value: '140,000 JPY' },
      { label: '2026-04 지출액', value: '162,000 JPY' },
      { label: '2026-05 지출액', value: '130,000 JPY' },
      { label: '2026-06 지출액', value: '245,000 JPY' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '6월 증가분은 이번에 매핑된 제노랩 증빙 3건(245,000 JPY)이 반영된 결과입니다.',
    postSuggestCards: [
      { id: 721, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 제노랩과의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 거래처의 거래 내역을 알려줘', responseKey: 'genolab-history' },
      { id: 722, title: '중복 거래 확인', metaType: null, desc: '동일한 거래가 중복으로\n입력되었는지 확인합니다.', actionLabel: '확인하기', actionStyle: 'solid', prompt: '동일한 거래가 중복으로 입력되었는지 확인해줘', responseKey: 'duplicate-check' },
    ],
    nextProActiveCards: [
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
      { id: 'invoice-journal', title: '인보이스 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '株式会社ニトリ에서 전송한청구서로 전표를 생성하였습니다.\n생성된 전표를 확인해주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '이메일 첨부파일을 확인하여 증빙 여부를 판단하고, 증빙인 경우 전표를 생성해 주세요.' },
    ],
  },
  'duplicate-check': {
    streamingTitle: '중복 거래 확인 중...',
    doneTitle: '중복 거래 확인 완료',
    steps: [
      { label: '최근 전표 내역을 조회하고 있어요' },
      { label: '거래처·금액·일자를 대조하고 있어요' },
      { label: '중복 의심 항목을 판별하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 세무 시스템에서 최근 전표와 이번 증빙 매핑 건을 비교해 중복 여부를 확인하고 있어요.',
    bubbleText: '중복 거래 확인이 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 세무 ▶ 중복 검증]', iconType: 'bar', done: true },
    ],
    resultText: '제노랩 증빙 3건 중 1건에서 중복 입력 의심 항목을 발견했습니다. 아래 내용을 확인해주세요.',
    workflowCards: [],
    tableRows: [
      { label: '회식비 (2026-06-28 · 120,000 JPY)', statusCls: 'stWarning', statusText: '중복 의심', judge: '동일 거래처·금액의 전표가 2026-06-25에도 존재', action: '전표 병합 또는 삭제 검토' },
      { label: '경조사비 (2026-06-28 · 80,000 JPY)', statusCls: 'stProgress', statusText: '정상', judge: '기존 전표와 일치하는 항목 없음', action: '조치 불필요' },
      { label: '다과·간식비 (2026-06-28 · 45,000 JPY)', statusCls: 'stProgress', statusText: '정상', judge: '기존 전표와 일치하는 항목 없음', action: '조치 불필요' },
    ],
    actionItems: [],
    note: '중복 의심 전표는 삭제 또는 병합 처리 후 다시 확인해주세요.',
    postSuggestCards: [
      { id: 731, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 제노랩과의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 거래처의 거래 내역을 알려줘', responseKey: 'genolab-history' },
      { id: 732, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
    ],
    nextProActiveCards: [
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
      { id: 'invoice-journal', title: '인보이스 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '株式会社ニトリ에서 전송한청구서로 전표를 생성하였습니다.\n생성된 전표를 확인해주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '이메일 첨부파일을 확인하여 증빙 여부를 판단하고, 증빙인 경우 전표를 생성해 주세요.' },
    ],
  },
  'receipt-journal': {
    steps: [
      { label: '첨부된 증빙 파일을 확인하고 있어요' },
      { label: '거래 정보와 세액을 분석하고 있어요' },
      { label: '전표 분개를 생성하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '첨부된 증빙(영수증)을 분석해 거래 정보와 전표 분개를 생성하고 있어요.',
    bubbleText: '생성된 전표를 확인한 후 전표로 전송해주세요. 추가 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[증빙 확인 ▶ 영수증 인식]', iconType: 'bar', done: false },
      { label: '[ERP 회계 ▶ 전표 생성]', iconType: 'doc', done: true },
    ],
    resultText: '첨부된 영수증을 분석하여 전표를 생성하였습니다. 내용을 확인한 후 전표로 전송해주세요.',
    transactionInfoBtnLabel: '영수증 원본 확인',
    transactionInfo: [
      { label: '거래 금액', value: '1,200 JPY' },
      { label: '세율', value: '10%' },
      { label: '소비세', value: '109 JPY' },
      { label: '거래일', value: '2026-03-19' },
      { label: '서류구분', value: '영수증' },
      { label: '결제 수단', value: '현금' },
      { label: '상호명', value: '北星タクシー株式会社' },
      { label: '인보이스 번호', value: 'T4430001062785' },
    ],
    journalEntry: {
      date: '2026-03-19',
      category: '매입세금',
      party: '北星タクシー株式会社',
      desc: '교통비',
      amount: '1,200',
      taxRate: '10%',
      taxAmt: '109',
      attachment: '출장비영수증.PNG',
      actionLabel: '전표 반영',
      rows: [
        { type: '차변', account: '여비교통비', debit: '1,200', credit: '-', taxRate: '10%', taxAmt: '109', party: '北星タクシー株式会社', desc: '교통비' },
        { type: '대변', account: '현금', debit: '-', credit: '1,200', taxRate: '-', taxAmt: '-', party: '北星タクシー株式会社', desc: '교통비' },
      ],
      totals: { debit: '1,200', credit: '1,200', taxAmt: '109' },
    },
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '첨부된 영수증 원본을 참고하여 전표 전송 전 금액과 거래처를 최종 확인해주세요.',
    postSuggestCards: [
      { id: 601, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 이 거래처와의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 거래처의 거래 내역을 알려줘', responseKey: 'taxi-history' },
      { id: 602, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
      { id: 603, title: '중복 거래 확인', metaType: null, desc: '동일한 거래가 중복으로\n입력되었는지 확인합니다.', actionLabel: '확인하기', actionStyle: 'solid', prompt: '동일한 거래가 중복으로 입력되었는지 확인해줘', responseKey: 'receipt-duplicate-check' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  'taxi-history': {
    streamingTitle: '거래 내역 조회 중...',
    doneTitle: '최근 6개월 거래 내역 조회 완료',
    steps: [
      { label: 'ERP 회계에서 거래처 정보를 확인하고 있어요' },
      { label: '최근 6개월 거래 내역을 조회하고 있어요' },
      { label: '월별 거래 금액을 정리하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 회계 시스템에서 北星タクシー株式会社와의 최근 6개월 거래 내역을 조회하고 있어요.',
    bubbleText: '최근 6개월 거래 내역 조회가 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 거래 내역]', iconType: 'bar', done: true },
    ],
    resultText: '최근 6개월(2026.01~2026.06)간 北星タクシー株式会社와의 거래 내역을 조회했습니다. 총 40건, 48,300 JPY 규모입니다.',
    leaseInfoTitle: '北星タクシー株式会社 최근 6개월 거래 내역',
    leaseInfoBtnLabel: '거래 내역 상세 보기',
    leaseInfo: [
      { label: '6개월 총 거래 금액', value: '48,300 JPY', note: '2026.01~2026.06 · 40건' },
      { label: '월 평균 거래 금액', value: '8,050 JPY' },
      { label: '2026-01 거래액', value: '8,400 JPY' },
      { label: '2026-02 거래액', value: '6,900 JPY' },
      { label: '2026-03 거래액', value: '10,500 JPY' },
      { label: '2026-04 거래액', value: '7,800 JPY' },
      { label: '2026-05 거래액', value: '9,300 JPY' },
      { label: '2026-06 거래액', value: '5,400 JPY' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '2026-03 거래에는 이번 출장비 영수증(1,200 JPY)이 포함되어 있습니다.',
    postSuggestCards: [
      { id: 611, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
      { id: 612, title: '중복 거래 확인', metaType: null, desc: '동일한 거래가 중복으로\n입력되었는지 확인합니다.', actionLabel: '확인하기', actionStyle: 'solid', prompt: '동일한 거래가 중복으로 입력되었는지 확인해줘', responseKey: 'receipt-duplicate-check' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  'receipt-duplicate-check': {
    streamingTitle: '중복 거래 확인 중...',
    doneTitle: '중복 거래 확인 완료',
    steps: [
      { label: '최근 전표 내역을 조회하고 있어요' },
      { label: '거래처·금액·일자를 대조하고 있어요' },
      { label: '중복 의심 항목을 판별하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 회계 시스템에서 최근 전표와 이번 영수증 건을 비교해 중복 여부를 확인하고 있어요.',
    bubbleText: '중복 거래 확인이 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 중복 검증]', iconType: 'bar', done: true },
    ],
    resultText: '北星タクシー株式会社 교통비 영수증에서 중복 입력 의심 항목을 발견했습니다. 아래 내용을 확인해주세요.',
    workflowCards: [],
    tableRows: [
      { label: '교통비 (2026-03-19 · 1,200 JPY)', statusCls: 'stWarning', statusText: '중복 의심', judge: '2026-03-18에 동일 거래처·동일 금액(1,200 JPY) 전표가 이미 등록되어 있음', action: '전표 병합 또는 삭제 검토' },
      { label: '교통비 (2026-03-15 · 980 JPY)', statusCls: 'stProgress', statusText: '정상', judge: '금액과 일자가 상이하여 중복 아님', action: '조치 불필요' },
      { label: '교통비 (2026-03-10 · 1,450 JPY)', statusCls: 'stProgress', statusText: '정상', judge: '금액과 일자가 상이하여 중복 아님', action: '조치 불필요' },
    ],
    actionItems: [],
    note: '중복 의심 전표는 삭제 또는 병합 처리 후 다시 확인해주세요.',
    postSuggestCards: [
      { id: 621, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 이 거래처와의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 거래처의 거래 내역을 알려줘', responseKey: 'taxi-history' },
      { id: 622, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  'natural-journal': {
    steps: [
      { label: '자연어 입력 내용을 분석하고 있어요' },
      { label: '거래처와 계정과목을 확인하고 있어요' },
      { label: '전표 분개를 생성하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '입력하신 자연어 내용을 분석해 거래 정보와 전표 분개를 생성하고 있어요.',
    bubbleText: '생성된 전표를 확인한 후 전표로 전송해주세요. 추가 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[자연어 입력 ▶ 거래 인식]', iconType: 'bar', done: false },
      { label: '[ERP 회계 ▶ 전표 생성]', iconType: 'doc', done: true },
    ],
    resultText: '입력하신 내용을 분석하여 전표를 생성하였습니다. 내용을 확인한 후 전표로 전송해주세요.',
    transactionInfoBtnLabel: '입력 내용 확인',
    transactionInfo: [
      { label: '거래 금액', value: '5,000 JPY' },
      { label: '세율', value: '10%' },
      { label: '소비세', value: '454 JPY' },
      { label: '거래일', value: '2026-05-20' },
      { label: '거래구분', value: '자연어 입력' },
      { label: '결제 수단', value: '카드' },
      { label: '거래처', value: '가라쿠' },
      { label: '인보이스 번호', value: 'T9430002001218' },
    ],
    journalEntry: {
      date: '2026-05-20',
      category: '매입세금',
      party: '가라쿠',
      desc: '직원 식대',
      amount: '5,000',
      taxRate: '10%',
      taxAmt: '454',
      actionLabel: '전표 반영',
      rows: [
        { type: '차변', account: '복리후생비', debit: '5,000', credit: '-', taxRate: '10%', taxAmt: '454', party: '가라쿠', desc: '직원 식대' },
        { type: '대변', account: '현금', debit: '-', credit: '5,000', taxRate: '-', taxAmt: '-', party: '가라쿠', desc: '직원 식대' },
      ],
      totals: { debit: '5,000', credit: '5,000', taxAmt: '454' },
    },
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '자연어로 입력된 내용을 기준으로 전표를 생성하였습니다. 전표 전송 전 금액과 거래처를 최종 확인해주세요.',
    postSuggestCards: [
      { id: 641, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 이 거래처와의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 거래처의 거래 내역을 알려줘', responseKey: 'garaku-history' },
      { id: 642, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
      { id: 643, title: '중복 거래 확인', metaType: null, desc: '동일한 거래가 중복으로\n입력되었는지 확인합니다.', actionLabel: '확인하기', actionStyle: 'solid', prompt: '동일한 거래가 중복으로 입력되었는지 확인해줘', responseKey: 'natural-duplicate-check' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  'garaku-history': {
    streamingTitle: '거래 내역 조회 중...',
    doneTitle: '최근 6개월 거래 내역 조회 완료',
    steps: [
      { label: 'ERP 회계에서 거래처 정보를 확인하고 있어요' },
      { label: '최근 6개월 거래 내역을 조회하고 있어요' },
      { label: '월별 거래 금액을 정리하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 회계 시스템에서 가라쿠와의 최근 6개월 거래 내역을 조회하고 있어요.',
    bubbleText: '최근 6개월 거래 내역 조회가 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 거래 내역]', iconType: 'bar', done: true },
    ],
    resultText: '최근 6개월(2026.01~2026.06)간 가라쿠와의 거래 내역을 조회했습니다. 총 6건, 28,000 JPY 규모입니다.',
    leaseInfoTitle: '가라쿠 최근 6개월 거래 내역',
    leaseInfoBtnLabel: '거래 내역 상세 보기',
    leaseInfo: [
      { label: '6개월 총 거래 금액', value: '28,000 JPY', note: '2026.01~2026.06 · 6건' },
      { label: '월 평균 거래 금액', value: '4,667 JPY' },
      { label: '2026-01 거래액', value: '4,200 JPY' },
      { label: '2026-02 거래액', value: '3,800 JPY' },
      { label: '2026-03 거래액', value: '5,500 JPY' },
      { label: '2026-04 거래액', value: '4,900 JPY' },
      { label: '2026-05 거래액', value: '5,000 JPY' },
      { label: '2026-06 거래액', value: '4,600 JPY' },
    ],
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '2026-05 거래에는 이번에 입력한 직원 식대(5,000 JPY)가 포함되어 있습니다.',
    postSuggestCards: [
      { id: 651, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
      { id: 652, title: '중복 거래 확인', metaType: null, desc: '동일한 거래가 중복으로\n입력되었는지 확인합니다.', actionLabel: '확인하기', actionStyle: 'solid', prompt: '동일한 거래가 중복으로 입력되었는지 확인해줘', responseKey: 'natural-duplicate-check' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  'natural-duplicate-check': {
    streamingTitle: '중복 거래 확인 중...',
    doneTitle: '중복 거래 확인 완료',
    steps: [
      { label: '최근 전표 내역을 조회하고 있어요' },
      { label: '거래처·금액·일자를 대조하고 있어요' },
      { label: '중복 의심 항목을 판별하고 있어요' },
    ],
    stepDur: 800,
    streamingText: 'ERP 회계 시스템에서 최근 전표와 이번 입력 건을 비교해 중복 여부를 확인하고 있어요.',
    bubbleText: '중복 거래 확인이 완료되었습니다. 추가로 확인이 필요하면 말씀해 주세요.',
    moduleChips: [
      { label: '[ERP 회계 ▶ 중복 검증]', iconType: 'bar', done: true },
    ],
    resultText: '가라쿠 직원 식대 전표에서 중복 입력 의심 항목을 발견했습니다. 아래 내용을 확인해주세요.',
    workflowCards: [],
    tableRows: [
      { label: '직원 식대 (2026-05-20 · 5,000 JPY)', statusCls: 'stWarning', statusText: '중복 의심', judge: '2026-05-19에 동일 거래처·동일 금액(5,000 JPY) 전표가 이미 등록되어 있음', action: '전표 병합 또는 삭제 검토' },
      { label: '직원 식대 (2026-04-15 · 4,900 JPY)', statusCls: 'stProgress', statusText: '정상', judge: '금액과 일자가 상이하여 중복 아님', action: '조치 불필요' },
      { label: '직원 식대 (2026-03-10 · 5,500 JPY)', statusCls: 'stProgress', statusText: '정상', judge: '금액과 일자가 상이하여 중복 아님', action: '조치 불필요' },
    ],
    actionItems: [],
    note: '중복 의심 전표는 삭제 또는 병합 처리 후 다시 확인해주세요.',
    postSuggestCards: [
      { id: 661, title: '최근 6개월 거래 내역', metaType: null, desc: '최근 6개월간 이 거래처와의\n거래 내역을 조회합니다.', actionLabel: '조회하기', actionStyle: 'outline', prompt: '최근 6개월 거래처의 거래 내역을 알려줘', responseKey: 'garaku-history' },
      { id: 662, title: '복리후생비 지출 현황', metaType: null, desc: '최근 6개월 복리후생비\n지출 현황을 확인합니다.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '최근 6개월 복리후생비 지출 현황을 알려줘', responseKey: 'welfare-expense-trend' },
    ],
    nextProActiveCards: [
      { id: 'evidence-mapping', title: '수임기업 증빙 파일 전표 반영', metaType: 'warn', metaText: '확인 필요', desc: '제노랩으로부터 수신한 증빙 파일을\n전표에 자동 매핑하였습니다. 전표를 확인해 주세요.', actionLabel: '확인하기', actionStyle: 'outline', prompt: '제노랩 증빙 파일이 자동 매핑된 전표를 확인하고 이상 여부를 점검해줘' },
      { id: 'tax-report', title: '7월 세무신고 — D-3', metaType: 'date', metaText: '마감일 2026.7.10 (일)', desc: '6월 원천세 신고가 3일 남았습니다.\n신고서 작성이 마감되지 않은 거래처를 확인하고 제출을 완료하세요.', actionLabel: '신고 확인', actionStyle: 'solid', prompt: '6월 원천세 신고 미완료 거래처 목록을 확인하고 제출 절차를 안내해줘' },
    ],
  },
  custom: {
    steps: [
      { label: '요청 내용을 확인하고 있어요' },
      { label: '관련 데이터를 분석하고 있어요' },
      { label: '답변을 정리하고 있어요' },
    ],
    stepDur: 960,
    streamingText: '요청하신 업무 흐름을 연결해 분석하고 있어요.',
    bubbleText: '다음 업무 연결 3가지를 제안드려요. 어떤 것부터 시작할까요?',
    moduleChips: [{ label: '[ProActive ▶ 분석 중]', iconType: 'bar', done: true }],
    resultText: '요청하신 업무 처리가 완료되었어요.',
    workflowCards: [],
    tableRows: [],
    actionItems: [],
    note: '',
    postSuggestCards: [],
    nextProActiveCards: INITIAL_PROACTIVE_CARDS,
  },
};
